import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/mobile.css";
import "@/security.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register PWA service worker (alleen in productie / non-dev)
// We registreren NIET op load maar zodra de DOM klaar is, zodat de
// installability-check van Chrome/Edge (die ±3s na load loopt) altijd
// een actieve service worker vindt — race conditions op trage Android
// toestellen worden zo voorkomen.
if ('serviceWorker' in navigator && window.location.protocol === 'https:') {
  const registerSW = () => {
    navigator.serviceWorker.register('/sw.js').then((reg) => {
      // Als er een nieuwe service worker in de wachtkamer staat → direct activeren
      // en de pagina éénmalig verversen zodat de nieuwe JS-bundles worden geladen.
      if (reg.waiting) reg.waiting.postMessage('SKIP_WAITING');
      reg.addEventListener('updatefound', () => {
        const nw = reg.installing;
        if (!nw) return;
        nw.addEventListener('statechange', () => {
          if (nw.state === 'installed' && navigator.serviceWorker.controller) {
            // Nieuwe SW is klaar — activeer 'em en reload één keer (met flag)
            nw.postMessage('SKIP_WAITING');
          }
        });
      });
      // Elke 30 min op update checken zodat lang-geopende tabs ook upgraden
      setInterval(() => { reg.update().catch(() => {}); }, 30 * 60 * 1000);
    }).catch(() => {
      /* niet kritiek — app blijft werken zonder SW */
    });
    // Herlaad éénmalig wanneer controller wisselt (= nieuwe SW overgenomen)
    let reloaded = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (reloaded) return;
      reloaded = true;
      window.location.reload();
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', registerSW, { once: true });
  } else {
    registerSW();
  }
}
